import { useState, useEffect, useRef, useId } from "react"

interface TextFilterProps {
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  debounceMs?: number
}

export function TextFilter({
  label,
  value,
  onChange,
  placeholder = "",
  debounceMs = 400,
}: TextFilterProps) {
  const id = useId()
  const [localValue, setLocalValue] = useState(value || "")
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  // Sync external -> local when value changes from outside
  useEffect(() => {
    setLocalValue(value || "")
  }, [value])

  const handleChange = (newValue: string) => {
    setLocalValue(newValue)
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      onChange(newValue)
    }, debounceMs)
  }

  return (
    <div className="space-y-1">
      <label htmlFor={id} className="text-xs font-medium text-muted-foreground">
        {label}
      </label>
      <input
        id={id}
        type="text"
        value={localValue}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        className="h-8 w-full rounded-md border border-input bg-transparent px-2 text-sm text-foreground outline-none"
      />
    </div>
  )
}
